import { allowedPostage, PostageUsageType, useInfinitePostage } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	CountryFlag,
	SelectItemType,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';

type SendsPostageControlType = {
	countryCode: string;
	label: string;
	name: string;
	control: any;
	unregister: any;
	getValues: any;
	defaultValues?: any;
	reset?: boolean;
};

function SendsPostageControl(props: SendsPostageControlType) {
	const { t } = useTranslation();

	const {
		isLoading: postageLoading,
		data: postageData,
		error: postageError,
	} = useInfinitePostage(props.countryCode, PostageUsageType.Sends);

	if (!props.countryCode) return null;

	const PostageOptions: Array<SelectItemType> = postageData
		? postageData.pages.map(
				(page) =>
					page?.data &&
					page.data.filter((postage, index: number) =>
						allowedPostage.includes(postage.value) ? { label: postage.label, value: postage.value } : null,
					),
			)[0]
		: [];

	return (
		<div className='form-group'>
			<label className='flex-row postage-label'>
				<CountryFlag countryCode={props.countryCode} />
				{`${props.countryCode} Postage`}
			</label>

			<Controller
				control={props.control}
				name={props.name}
				rules={{
					required: t('validation.required'),
				}}
				defaultValue={props.defaultValues}
				render={({ field }) => (
					<ComboBoxControl
						name={props.name}
						placeholder='Select Postage...'
						data={PostageOptions}
						defaultValue={props.defaultValues}
						loading={postageLoading}
						valueType='number'
						formReset={props.reset}
						forwardValuesCallback={(e) => field.onChange(e)}
						displayType={ComboBoxTypeEnum.Multi}
						displayItemLabelType={ComboBoxItemDisplayEnum.Label}
					/>
				)}
			/>
		</div>
	);
}

export default SendsPostageControl;
